<p [ngClass]="{'home-title' : isHome, 'page-title' : !isHome }">Retirement healthcare <br *ngIf="isHome"/>cost calculator</p>
<router-outlet></router-outlet>
<!-- FOR MOBILE -->
<div class="footer-text" *ngIf="mobileEnabled">
    <p>
        The HSA calculator is for illustrative purposes only and the results shown are purely hypothetical and not meant
        to
        reflect any actual investment. The principal value and return of your account will fluctuate.
    </p>
    <p>
        You are solely responsible for the accuracy of any data you enter into this calculator and the calculations are
        based on the information you have entered. The simplified tax calculations also do not take into account any
        other
        pre-tax deferrals, such as your reimbursement accounts for health plan or dental insurance, or other payroll
        taxes,
        such as FICA. The results you receive from this calculator do not account for tax effects of any kind.
    </p>
    <p>
        Your circumstances are unique; therefore, you need to assess your own situation and consult an financial advisor
        if
        you feel you need more personal advice. Also, your circumstances will change over time, so review your financial
        strategy periodically to be sure it continues to fit your situation. All examples are hypothetical and are
        intended
        for illustrative purposes only.
    </p>
    <p>
        Investment accounts are not FDIC insured and they are not bank guaranteed. Investment accounts are not a deposit
        account, or an obligation of HSA Bank, and they may lose value. They are not guaranteed by any federal
        government
        agency. Performance data and ratings represent past performance and are not a guarantee of future results.
        Investment returns and principal value will fluctuate and investors' shares, when sold, may be worth more or
        less
        than their original cost.
    </p>
    <p>
        &copy;{{ currentYear }} HSA Bank. HSA Bank is a division of Webster Bank, N.A., Member FDIC.<br/>
        Plan Administrative Services and Benefit Services are administered by Webster Servicing LLC. <br/>
        FL license #L133045 | OK license #3004144337
    </p>
</div>